export enum CompendiumDatabaseEnum {
  SP,
  DB,
}
